export const productSaleToolbarConfig = [
  {
    id: "searchProductSale",
    titleText: "Search",
    textWithIcon: true,
    isIcon: true,
    iconClass: "ic:outline-search",
    buttonTypeClassName: "default-btn border-right",
    actionName: "SEARCH",
  },
  {
    id: "saveProductSale",
    titleText: "Save",
    textWithIcon: true,
    isIcon: true,
    iconClass: "ion:save-outline",
    buttonTypeClassName: "default-btn border-right",
    actionName: "SAVE",
  },

  {
    id: "newProductSale",
    titleText: "New",
    textWithIcon: true,
    isIcon: true,
    iconClass: "fluent:document-add-28-regular",
    buttonTypeClassName: "default-btn border-right",
    actionName: "NEW",
  },
  {
    id: "quote",
    titleText: "Quote",
    textWithIcon: true,
    isIcon: true,
    iconClass: "mdi:comment-quote-outline",
    buttonTypeClassName: "default-btn border-right",
    actionName: "SEARCH",
  },
  {
    id: "PickListProductSale",
    titleText: "Pick List",
    textWithIcon: true,
    isIcon: true,
    iconClass: "mdi:list-box-outline",
    buttonTypeClassName: "default-btn border-right",
    actionName: "SEARCH",
  },
  {
    id: "Invoice",
    titleText: "Invoice",
    textWithIcon: true,
    isIcon: true,
    iconClass: "mdi:receipt-text-outline",
    buttonTypeClassName: "default-btn border-right",
    actionName: "DAndI",
  },
  {
    id: "packingList",
    titleText: "Packing List",
    textWithIcon: true,
    isIcon: true,
    iconClass: "mdi:clipboard-list-outline",
    buttonTypeClassName: "default-btn border-right",
    actionName: "INSPECTION",
  },
  {
    id: "deleteProductSale",
    titleText: "Delete Product Sale",
    textWithIcon: true,
    isIcon: true,
    iconClass: "fluent:delete-24-regular",
    buttonTypeClassName: "default-btn",
    actionName: "DELETE",
  },
];
export const productSaleDeleteBtnConfig = [];
